import * as FingerprintJS from '@fingerprintjs/fingerprintjs-pro';

import { UserDefault, UserSession } from '../user';

import { ApiUser } from '@src/lib/commonLib/api/client/V1';

// FP-OFF 핑거프린트 전역 비활성 스위치 (2026-07-27, 백엔드 visitor-id 검사 제거 확인됨).
//   true = 아래 fetch/validate 전부 no-op(빈값 반환). 원본 로직은 그대로 보존.
//   ▶ 복구: 이 값을 false 로 바꾸면 원상복구 (+ UserDefault.ts 의 FP-OFF 2줄 주석해제).
const FINGERPRINT_DISABLED: boolean = true;

export namespace VisitorUtils {
  const isExistCheckVisitorId = async (): Promise<string> => {
    const fId = UserSession.getFingerPrintId();
    const hostName = window.location.hostname;
    const accessDomain =
      hostName.includes('localhost') ||
      hostName.includes('global.toptoon.com') ||
      hostName.includes('toptoon.com');
    if (!accessDomain) return '';
    if (fId) {
      return fId;
    }
    return '';
  };

  export const fetchVisitorId = async (
    forceFetch: boolean = false,
  ): Promise<string> => {
    if (FINGERPRINT_DISABLED) return Promise.resolve(''); // FP-OFF 생성 안 함
    if (!forceFetch) {
      const v_value = await isExistCheckVisitorId();
      if (v_value) {
        return Promise.resolve(v_value);
      }
    }

    try {
      const fpPromise = FingerprintJS.load({
        apiKey: `${process.env.FINGER_PRINT_KEY}`,
        endpoint: `${process.env.FINGER_PRINT_DOMAIN}`,
        scriptUrlPattern: [
          `${process.env.FINGER_PRINT_DOMAIN}/web/v<version>/<apiKey>/loader_v<loaderVersion>.js`,
        ],
      });

      const fp = await fpPromise;
      const r = await fp.get();

      if (!r || !r.visitorId) {
        return Promise.resolve('');
      }

      UserSession.isNeedValidateVisitorId.setter();
      UserSession.setFingerPrintId(r.visitorId);
      return Promise.resolve(r.visitorId);
    } catch (e) {
      console.warn(e);
      return Promise.resolve('');
    }
  };

  export const validateVisitorId = async (): Promise<string> => {
    if (FINGERPRINT_DISABLED) return Promise.resolve(''); // FP-OFF 검증 안 함
    if (
      (!UserSession.isRefreshVisitorId.check() ||
        UserSession.isNeedValidateVisitorId.getter()) &&
      UserSession.getFingerPrintId()
    ) {
      const res = await new ApiUser(
        UserDefault.getUserSession(),
      ).checkValidatedVisitorId();
      return res.data?.data?.expiredAt;
    } else if (!UserSession.getFingerPrintId()) {
      return Promise.resolve('');
    }
    return Promise.reject();
  };

  // site check 유효성 검사 용
  export const testValidateVisitorId = async (): Promise<string> => {
    if (FINGERPRINT_DISABLED) return Promise.resolve(''); // FP-OFF 검증 안 함
    if (UserSession.getFingerPrintId()) {
      const res = await new ApiUser(
        UserDefault.getUserSession(),
      ).checkValidatedVisitorId();
      return res.data?.data?.expiredAt;
    } else if (!UserSession.getFingerPrintId()) {
      return Promise.resolve('');
    }
    return Promise.reject();
  };
}
